import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { createContext, useReducer } from 'react';

const SHOW_MODAL = 'SHOW_MODAL';
const HIDE_MODAL = 'HIDE_MODAL';

export const GenericModalContext = createContext(null);

const initialState = {
  open: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        open: true,
      };
    case HIDE_MODAL:
      return {
        ...state,
        open: false,
      };
    default:
      return {
        ...state,
      };
  }
};

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1350, // theme.zIndex.drawer + 1
    color: 'white',
  },
}));

const showModalAction = () => ({ type: SHOW_MODAL });
const hideModalAction = () => ({ type: HIDE_MODAL });

const GenericModalContextProvider = ({ children }) => {
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);
  const showLoader = () => dispatch(showModalAction());
  const hideLoader = () => dispatch(hideModalAction());

  const handleLoader = (isLoading) => {
    if (isLoading) showLoader();
    else hideLoader();
  };
  return (
    <GenericModalContext.Provider value={{ handleLoader }}>
      <Backdrop className={classes.backdrop} open={state.open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </GenericModalContext.Provider>
  );
};

export default GenericModalContextProvider;
